// Device type constants and enums

export enum DeviceType {
  MOBILE_PHONE = 'mobile_phone',
  IPHONE = 'iphone',
  IPHONE_PRO = 'iphone_pro',
  ANDROID = 'android',
  TABLET = 'tablet',
  LAPTOP = 'laptop',
  DESKTOP = 'desktop',
  ULTRAWIDE = 'ultrawide',
  TV = 'tv',
  WATCH = 'watch'
}

// Device display names mapping
export const DEVICE_DISPLAY_NAMES: Record<DeviceType, string> = {
  [DeviceType.MOBILE_PHONE]: 'Mobile Phone',
  [DeviceType.IPHONE]: 'iPhone',
  [DeviceType.IPHONE_PRO]: 'iPhone Pro',
  [DeviceType.ANDROID]: 'Android',
  [DeviceType.TABLET]: 'Tablet',
  [DeviceType.LAPTOP]: 'Laptop',
  [DeviceType.DESKTOP]: 'Desktop',
  [DeviceType.ULTRAWIDE]: 'Ultrawide',
  [DeviceType.TV]: 'Smart TV',
  [DeviceType.WATCH]: 'Smartwatch'
}

// Device compatibility mapping for legacy support
export const DEVICE_COMPATIBILITY_MAP: Record<string, DeviceType> = {
  'mobile_phone': DeviceType.MOBILE_PHONE,
  'mobile': DeviceType.MOBILE_PHONE,
  'phone': DeviceType.MOBILE_PHONE,
  'iphone': DeviceType.IPHONE,
  'iphone-pro': DeviceType.IPHONE_PRO,
  'iphone_pro': DeviceType.IPHONE_PRO,
  'android': DeviceType.ANDROID,
  'tablet': DeviceType.TABLET,
  'laptop': DeviceType.LAPTOP,
  'desktop': DeviceType.DESKTOP,
  'ultrawide': DeviceType.ULTRAWIDE,
  'tv': DeviceType.TV,
  'watch': DeviceType.WATCH
}

// All available device types
export const ALL_DEVICE_TYPES: DeviceType[] = [
  DeviceType.MOBILE_PHONE,
  DeviceType.IPHONE,
  DeviceType.IPHONE_PRO,
  DeviceType.ANDROID,
  DeviceType.TABLET,
  DeviceType.LAPTOP,
  DeviceType.DESKTOP,
  DeviceType.ULTRAWIDE,
  DeviceType.TV,
  DeviceType.WATCH
]